import { BodyCopy, Heading02, Heading05, Typelockup } from '@uds/typography';
import { Maybe } from 'core';
import ShortcodeText from 'presentation/components/Shortcode';

type Props = {
  domains: number;
  eyebrow: Maybe<string>;
  title: string;
  subtitle: Maybe<string>;
};

export default function DomainSearchTypeLockup({ domains, eyebrow, title, subtitle }: Readonly<Props>): JSX.Element {
  return (
    <Typelockup
      eyebrow={eyebrow == null ? undefined : <Heading05 component="h2">{eyebrow}</Heading05>}
      heading={
        <Heading02>
          <ShortcodeText code={title} values={{ count: domains.toString() }} />
        </Heading02>
      }
      subheading={subtitle == null ? undefined : <BodyCopy>{subtitle}</BodyCopy>}
    />
  );
}
